import {
  Component,
  ElementRef,
  HostBinding,
  inject,
  viewChild,
} from '@angular/core';
import { FlowpilotSidebarLayoutComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/sidebar/flowpilot-sidebar-layout.component';
import { FlowpilotChatsActionsComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/chats/flowpilot-chats-actions.component';
import { FlowpilotChatsListComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/chats/flowpilot-chats-list.component';
import { FlowpilotSidebarService } from '@core/components/sidebar/components/flowpilot/window/content/services/flowpilot-sidebar.service';

@Component({
  selector: 'app-flowpilot-sidebar',
  imports: [
    FlowpilotSidebarLayoutComponent,
    FlowpilotChatsActionsComponent,
    FlowpilotChatsListComponent,
  ],
  styles: [
    `
      :host {
        overflow: hidden;
        flex-shrink: 0;
      }
    `,
  ],
  template: `
    <app-flowpilot-sidebar-layout #container>
      <app-flowpilot-chats-actions actions />

      <app-flowpilot-chats-lists chats />
    </app-flowpilot-sidebar-layout>
  `,
})
export class FlowpilotSidebarComponent {
  /** INJECTIONS **/
  /****/
  private readonly sidebarService = inject(FlowpilotSidebarService);

  /****/
  private readonly el = inject(ElementRef<HTMLElement>);

  /** PROPERTIES **/
  /****/
  private readonly sidebarContainer =
    viewChild.required<FlowpilotSidebarLayoutComponent>('container');

  constructor() {
    this.sidebarService.init(this.el.nativeElement);
  }

  @HostBinding('style.width.px')
  get width() {
    return this.sidebarContainer().sidebarWidthSignal();
  }

  @HostBinding('style.transition')
  get transition() {
    if (this.sidebarContainer().resizingSignal()) return undefined;
    else return 'width 0.25s ease-in-out';
  }
}
